// extracted by mini-css-extract-plugin
export default {"root":"Select_root__Ih+LI","input":"Select_input__QviqT"};